export default __webpack_public_path__ + "static/media/IMG_1431.d18736da.jpg";